"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    content: {
      padding: spacing(2),
      overflowY: 'scroll',
      maxHeight: 250,
      wordBreak: 'break-word',
      whiteSpace: 'pre-line',
      '&:last-child': {
        paddingBottom: spacing(2)
      }
    }
  };
});

var MessageCard = function MessageCard(_ref2) {
  var message = _ref2.message;
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 1),
      isExpanded = _useState2[0];

  return /*#__PURE__*/_react.default.createElement(_material.Card, null, /*#__PURE__*/_react.default.createElement(_material.CardContent, {
    classes: {
      root: classes.content
    }
  }, message), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: isExpanded,
    timeout: "auto",
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement(_material.CardContent, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    paragraph: true
  }, "Method:"))));
};

var _default = MessageCard;
exports.default = _default;